import styled from "styled-components";
import { Outlet } from "react-router-dom";
const Container = styled.div`
  width: 97%;
  margin: auto;
  margin-top: 20px;
  @media screen and (min-width: 480px) {
    width: 100%;
    margin: 0;
    margin-top: 0;
  }
`;

function Home() {
  return <Container>{<Outlet />}</Container>;
}

export default Home;
